import { render, staticRenderFns } from "./ProductFilters.vue?vue&type=template&id=c84b288a"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductFilters.vue?vue&type=style&index=0&id=c84b288a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports